import { forwardRef, useEffect } from 'react';
import Select from 'react-select';
import styled from '@xstyled/styled-components';
import { useAtom } from 'jotai';
import { addToCartErrorAtom, productVariantsAtom } from 'global/store';
import { useTranslation } from 'next-i18next';



const StyledSelect = styled(Select)`
  flex: 1;
  max-width: 310px;
`;

const VariantSelect = forwardRef((props, ref) => {
  const { t } = useTranslation();

  const [variants, setVariants] = useAtom(productVariantsAtom);
  const [error] = useAtom(addToCartErrorAtom);

  const selectedVariant = {
    attribute: 'custom',
    uid: props.value?.uid,
    name: props.value?.attribute
  };

  useEffect(() => {
    if (props.value) {
      const variantSelected = variants?.find(
        item => item.name === props.value.attribute
      );

      if (variantSelected) {
        const selected = variants?.filter(item => item !== variantSelected);
        setVariants([...selected, selectedVariant]);
      } else {
        setVariants([...variants, selectedVariant]);
      }
    } else if (props.value === null) {
      setVariants([]);
    }
  }, [props.value]);

  useEffect(() => {
    variants?.length === 0 ? props.reset() : props.setGallery();
  }, [variants]);

  return (
    <StyledSelect
      ref={ref}
      isClearable
      escapeClearsValue
      name={props.name}
      value={props.value || null}
      onChange={props.onChange}
      options={props.options}
      placeholder={t('ui.choose')}
      styles={{
        container: (base, state) => ({
          ...base,
          marginBottom: '2rem',
          opacity: state.isDisabled ? 0.4 : 1
        }),
        control: base => ({
          ...base,
          border: 'none',
          boxShadow: 'none',
          borderRadius: '0',
          borderBottom: `2px solid ${error ? 'red' : '#A8A9BA'}`,
          border: error ? '2px solid red' : 'none',
          background: '#fff',
          '&:hover': {
            borderBottom: '2px solid #9596AC'
          }
        }),
        placerholder: base => ({
          ...base,
          '&:hover': {
            color: '#9596AC'
          }
        }),
        indicatorSeparator: () => ({
          display: 'none'
        }),
        dropdownIndicator: (base, state) => ({
          ...base,
          position: 'relative',
          left: '0.25rem',
          color: '#A8A9BA',
          cursor: 'pointer',
          transform: state.selectProps.menuIsOpen
            ? 'scale(1.3) rotate(180deg)'
            : 'scale(1.3)',
          transition: 'all 0.3s',
          '&:hover': {
            color: '#9596AC'
          }
        }),
        option: (base, state) => ({
          ...base,
          background: state.isSelected ? '#D6D7EA' : 'white',
          cursor: 'pointer',
          ':hover': {
            background: '#D6D7EA'
          }
        }),
        clearIndicator: base => ({
          ...base,
          cursor: 'pointer',
          '&:hover': {
            color: '#9596AC'
          }
        })
      }}
    />
  );
});

VariantSelect.displayName = 'VariantSelect';

export default VariantSelect;
